import { get, post, del, put } from 'services/api-client';
import { createTarget } from "utils/url";

const employeeService = {
  create: (data) => post(`/employee/create`, data),

  createProfile: (data) => post(`/employee/profile/create`, data),

  delete: (id) => del(`/employee/${id}`),

  changeRole: (id, newRole) => put(`/employee/${id}?newRole=${newRole}`),

  getByUserId: (userId) => get(`/employee/user/${userId}`),

  resendInvite: (id) => post(`/employee/${id}/resend-invite`),

  createProvider: (data) => post(`/employee/provider/create`, data),

  updateProvider: (data) => put(`/employee/provider/update`, data),

  getByEmployeeId: (employeeId) => get(`/employee/${employeeId}`),

  getProvidersAsSelectListItems: (clientId = null) => get(createTarget("/employee/provider/select-list")(clientId)()),

  getAll: (id = null) => get(createTarget("/employee/all")(id)()),
}

export default employeeService;